import * as yup from "yup";
export const EmployeeCreateSchema = yup.object().shape({
  firstName: yup.string().required("Required"),
  position: yup.string().required("Required"),
  gender: yup.string().required("Required"),
  lastName: yup.string().required("Required"),
  personalEmail: yup.string().required("Required"),
  contactNumber: yup
    .string()
    .matches(/^\d{10}$/, "Mobile no. must be exactly 10 digits and postive")
    .required("Required"),
  aadharcardNumber: yup
    .string()
    .matches(/^\d{12}$/, "Aadhar no. must be exactly 12 digits and postive")
    .required("Required"),
  pancardNumber: yup
    .string()
    .matches(
      /^([A-Z]){5}([0-9]){4}([A-Z]){1}$/,
      "PAN number must be in the format ABCDE1234F"
    )
    .required("Required"),
  permanantAddress: yup
    .string()
    .min(10, "must be at least 10 characters")
    .required("Required"),
  residentialAddress: yup
    .string()
    .min(10, "must be at least 10 characters")
    .required("Required"),
  dateOfJoining: yup.date().required(),
  roleInOrganisation: yup
    .string()
    .required("Required")
    .oneOf(
      [
        "superAdmin",
        "purchaseStaff",
        "saleStaff",
        "agronomistStaff",
        "opsStaff",
        "inspectionStaff",
        "marketingStaff",
        "adminStaff",
        "labourStaff",
        "accountStaff",
        "ITStaff",
        "SMMStaff",
        "salesManager",
        "clientFeedback",
        "HR",
        "Jr.HR",
        "salesCoordinator",
        "officeStaff",
        "marketingAgency",
        null,
      ],
      "Invalid role value"
    ),
  packageJoinedAt: yup.number(),
  city: yup.string().required("Required"),
  interviewDate: yup.date().required(),
});
